import React, { useState, useEffect } from 'react';

import { Form, Button, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import FonctionService from 'Services/FonctionService';
import GroupService from 'Services/GroupService';
import ProjetService from 'Services/ProjetService';
import { Formik } from 'formik';
import * as yup from 'yup';
import Select from 'react-select';

import { nullToEmptyStringOrDefault, toReactSelectObject } from 'Utils/Helpers';

const schema = yup.object({
    parentId: yup.string(),
    groupId: yup.string().required(),
    projetId: yup.string(),
    dA_VALIDATOR: yup.boolean(),
    selF_DA_VALIDATOR: yup.boolean(),
});

const CreateOrEdit = (props) => {
    const history = useHistory();
    // const { register, handleSubmit, errors } = useForm();

    const [fonction, setFonction] = useState(null);
    const [groups, setGroups] = useState([]);
    const [projets, setProjets] = useState([]);
    const [fonctions, setFonctions] = useState([]);

    const {
        match: { params },
    } = props;

    useEffect(() => {
        FonctionService.getFonctions()
            .then((result) => {
                if (result.status === 200) {
                    setFonctions(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        GroupService.getGroups()
            .then((result) => {
                if (result.status === 200) {
                    setGroups(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        ProjetService.getProjets()
            .then((result) => {
                if (result.status === 200) {
                    setProjets(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        if (params.fonctionId) {
            FonctionService.getFonctionById(params.fonctionId)
                .then((result) => {
                    if (result.status === 200) {
                        setFonction(result.data);
                        // console.log(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const submitForm = (data) => {
        FonctionService.saveFonction({ fonctionId: params.fonctionId, ...data })
            .then((result) => {
                // console.log(result.data);
                if (result.status === 200) {
                    history.push('/admin/fonction/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/fonction/index' }}>
                    Fonctions
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{params.fonctionId ? 'Edit Fonction' : 'Create New Fonction'}</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.fonctionId ? 'Edit Fonction' : 'Create New Fonction'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.fonctionId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            parentId: fonction ? nullToEmptyStringOrDefault(fonction.parentId) : '',
                            groupId: fonction ? nullToEmptyStringOrDefault(fonction.groupId) : '',
                            projetId: fonction ? nullToEmptyStringOrDefault(fonction.projetId) : '',
                            dA_VALIDATOR:
                                fonction && fonction.fonctionPermissions && fonction.fonctionPermissions.length > 0
                                    ? fonction.fonctionPermissions[0].dA_VALIDATOR
                                    : false,
                            selF_DA_VALIDATOR:
                                fonction && fonction.fonctionPermissions && fonction.fonctionPermissions.length > 0
                                    ? fonction.fonctionPermissions[0].selF_DA_VALIDATOR
                                    : false,
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors, setFieldValue, setFieldTouched }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="exampleForm.ControlTextarea99">
                                    <Form.Label>Parent</Form.Label>
                                    <Select
                                        name="parentId"
                                        value={toReactSelectObject(
                                            fonctions.find((fonction) => fonction.fonctionId === values.parentId),
                                            'name',
                                            'parentId',
                                        )}
                                        onChange={(option) => setFieldValue('parentId', option.value)}
                                        options={fonctions.map((fonction) =>
                                            toReactSelectObject(fonction, 'name', 'fonctionId'),
                                        )}
                                        isInvalid={!!errors.parentId}
                                        onBlur={() => setFieldTouched('parentId', true)}
                                        placeholder="-"
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.parentId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea99">
                                    <Form.Label>Projet</Form.Label>
                                    <Select
                                        name="projetId"
                                        value={toReactSelectObject(
                                            projets.find((projet) => projet.projetId === values.projetId),
                                            'name',
                                            'projetId',
                                        )}
                                        onChange={(option) => setFieldValue('projetId', option.value)}
                                        options={projets.map((projet) =>
                                            toReactSelectObject(projet, 'name', 'projetId'),
                                        )}
                                        isInvalid={!!errors.projetId}
                                        onBlur={() => setFieldTouched('projetId', true)}
                                        placeholder="-"
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.projetId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea99">
                                    <Form.Label>Group</Form.Label>
                                    <Select
                                        name="groupId"
                                        value={toReactSelectObject(
                                            groups.find((group) => group.groupId === values.groupId),
                                            'name',
                                            'groupId',
                                        )}
                                        onChange={(option) => setFieldValue('groupId', option.value)}
                                        options={groups.map((group) => toReactSelectObject(group, 'name', 'groupId'))}
                                        isInvalid={!!errors.groupId}
                                        onBlur={() => setFieldTouched('groupId', true)}
                                        placeholder="-"
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.groupId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox11111111111">
                                    <Form.Check
                                        type="checkbox"
                                        label="DA_VALIDATOR"
                                        name="dA_VALIDATOR"
                                        checked={values.dA_VALIDATOR}
                                        onChange={handleChange}
                                        isInvalid={!!errors.dA_VALIDATOR}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.dA_VALIDATOR}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox2222222222222222">
                                    <Form.Check
                                        type="checkbox"
                                        label="SELF_DA_VALIDATOR"
                                        name="selF_DA_VALIDATOR"
                                        checked={values.selF_DA_VALIDATOR}
                                        onChange={handleChange}
                                        isInvalid={!!errors.selF_DA_VALIDATOR}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.selF_DA_VALIDATOR}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Button variant="primary" type="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default CreateOrEdit;
